import React, {Component} from 'react';
import $ from 'jquery';
import StaticHeader from "./StaticHeader";
import {Link, NavLink, Redirect} from "react-router-dom";
import {authService} from "./auth";
import "../src/profile/container/profile/css/main-profile.min.css";
import "../src/project/container/Project/css/main-projects.min.css";
import axios from "axios";
import uuid from "react-uuid";
import * as _ from "lodash";
import {getCDNUrl, getOptimizedCoverImage} from "./commons/CommonFunctions";
import ReadMoreReadLess from "./commons/ReadMoreReadLess";
import mappingUtils from "./project/component/commons/utils/mappingUtils";
import UnauthSpecialitiesPopUp from "./profile/component/PersonalProfile/UnauthSpecialitiesPopUp";
import PrivateProfile from "./profile/container/profile/PrivateProfile";
import AuthModalComponent from "./LoginExtra/AuthModalComponent";
import SignUpModal from "./SignUpModal/signUpModal";
import LeftPanelUnauth from "./commons/LeftPanelUnauth";
import { getUserPostCount } from './services/StudioApi';

class BusinessProfileByPass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            loginSuccess: authService.isAuthenticated(),
            userDetails: props.userDetails,
            sharingConfig: {},
            privacySetting:{},
            pathname:'',
            userPostCountData: {}
        }

    }

    handleLoginClose = () => {
        this.setState({'loginRequired': false})
        window.$('#loginModal').modal('hide');
    }

    signUpRequired=()=>{
        this.setState({'signUpRequired':true})
        window.$('#signupModal').modal('show');
    }

    handleSignUpClose = () => {
        this.setState({'signUpRequired': false})
        window.$('#signupModal').modal('hide');
    }

    componentDidMount() {
        // window.$(".projtopbar").sticky({topSpacing: 65, responsiveWidth: true});
        // if (window.$('#sticky-wrapper').hasClass('sticky-wrapper'))
        //     window.$('.projectinn').css({'padding-bottom' : '150px'});
        
        if(this.state.userDetails?.unauthPageShow) {
            var navPos = window.$('.projtopbar').offset().top - 64;
            window.$(window).scroll(function () {
                var windscroll = window.$(window).scrollTop();
                if (windscroll >= navPos) {
                    window.$('.projtopbar').addClass('is-sticky');
                } else {
                    window.$('.projtopbar').removeClass('is-sticky');
                }
            });
        }
        
            
        window.$(".unauthLoginPopclose").click(function(){
            window.$(".bkbackdrop2").hide();
        });

        window.$('#header .iCross').hide();
        window.$("#header .iHamburger").on('click', function (event) {
            window.$('.leftpanel').addClass('navactive');
            window.$('.dgcontainer').addClass('navactive');
            window.$('.staticPage').addClass('navactive');
            window.$('#header .iHamburger').hide();
            window.$('#header .iCross').show();
        });
        $("body, html").on('click', function (event) {
            if (!$(event.target).closest('#header .iHamburger, .read-more-less-btn').length) {
                $('.leftpanel').removeClass('navactive');
                $('.dgcontainer').removeClass('navactive');
                window.$('.staticPage').removeClass('navactive');
                $('.dropdown-menu.show').removeClass('show');
                window.$('#header .iHamburger').show();
                window.$('#header .iCross').hide();
            }
        });
        window.$('.usermenu .dropdown-submenu > a').on("click", function (e) {
            var submenu = $(this);
            $('.usermenu .dropdown-submenu .dropdown-menu').removeClass('show');
            submenu.next('.usermenu .dropdown-menu').addClass('show');
            e.stopPropagation();
        });

        this.getSharingConfig();
        this.getPrivacySettingConfig();
        this.getUserPostCount();
    }

    sanitize(url) {
        let PROTOCOL_WHITELIST = ['http://', 'https://'];
        if (url) {
            for (let i = 0; i < PROTOCOL_WHITELIST.length; i++)
                if (url.startsWith(PROTOCOL_WHITELIST[i]))
                    return url;
            return 'http://' + url
        }
        return url;
    }

    openContactInfo = (event)=>{
        event.preventDefault();
        window.$('#contactInfopop').modal('show');

    }

    componentWillUnmount() {
        window.$('#contactInfopop').modal('hide');
    }



    getSharingConfig = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/unauth/get/sharing-config?customUrl=' + this.props.customUrl,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res.status === '200 OK') {
                this.setState({'sharingConfig': res.body})
            }

        }).catch((err) => {
            if (err && err.response) {
                this.setState({
                    error: {message: err.response.data.message, err: err.response}
                })
            }
        });
    };

    getPrivacySettingConfig = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/unauth/get/privacy-setting-config?customUrl=' + this.props.customUrl,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res.status === '200 OK') {
                this.setState({'privacySetting': res.body})
            }

        }).catch((err) => {
            if (err && err.response) {
                this.setState({
                    error: {message: err.response.data.message, err: err.response}
                })
            }
        });
    };

    getOptimizedImage(personalInfo) {
        if (personalInfo.resizedProfileImages && personalInfo.resizedProfileImages['200x200'] != null) {
            return personalInfo.resizedProfileImages['200x200'];
        }
        return personalInfo.profileImage;
    }
    loginRequired=()=> {
        this.setState({'loginRequired': true})
        window.$('#loginModal').modal('show');
    }


    redirect() {

    }

    redirectToDeactivation = (event) => {
        (this.props.history.push({
            pathname: '/unavailable',
            state: {
                customUrl:this.props.customUrl,
            }
        }))
    }

    getUserPostCount = async () => {
        let response = await getUserPostCount({"userId": this.state.userDetails?.id});
        if(response?.message === "Success!") {
            this.setState({
                userPostCountData: response.body
            })
        }
    }

    render() {
        const parent = {height: '19px'}
        const { userPostCountData } = this.state;
        if (this.state.userDetails && this.state.userDetails.deactivated) {
            return (
                <div>{this.redirectToDeactivation()}</div>)
        } else{

            return ( <div className="projectpage staticPage">
                    <div className="wrapper projectpage profilepage pabout unauthProfilePg">
                        <div className="wrapper projectpage nologinpage">
                            {this.state.userDetails.unauthPageShow === false ?<PrivateProfile/>:
                                this.state.userDetails.unauthPageShow ?
                                    <><StaticHeader/>
                                        <main className="dgcontainer hm3col">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-md-9">
                                                        <div className="projectinn organizePage">
                                                            <div className="profbannwrap">
                                                                <a data-fancybox={uuid()}
                                                                href={this.state.userDetails && this.state.userDetails.personalInfo && this.state.userDetails.personalInfo.coverImage ? getCDNUrl(this.state.userDetails.personalInfo.coverImage) : "https://cdn.dscovr.com/images/prof-banner.png"}
                                                                alt="">
                                                                    {this.state.userDetails && this.state.userDetails.personalInfo  ?
                                                                        < img
                                                                            src={this.state.userDetails && this.state.userDetails.personalInfo && this.state.userDetails.personalInfo.coverImage ? getCDNUrl(this.state.userDetails.personalInfo.coverImage) : "https://cdn.dscovr.com/images/prof-banner.png"}
                                                                            alt=""/> : null
                                                                    }
                                                                </a>
                                                            </div>
                                                            <div className="projtopbar company">
                                                                <div className="profpic">
                                                                    {this.state.userDetails && this.state.userDetails.type && this.state.userDetails.type === 'COMPANY' ?

                                                                        <a data-fancybox={uuid()}
                                                                        href={this.state.userDetails && this.state.userDetails.personalInfo && this.state.userDetails.personalInfo.profileImage ? getCDNUrl(this.state.userDetails.personalInfo.profileImage) : mappingUtils.returnDefaultImage(this.state.userDetails.type)}>
                                                                            {this.state.userDetails ?
                                                                                <img
                                                                                    src={(this.state.userDetails.personalInfo) && !_.isNull(this.state.userDetails.personalInfo.profileImage) ? getCDNUrl(this.getOptimizedImage(this.state.userDetails.personalInfo)) : mappingUtils.returnDefaultImage(this.state.userDetails.type)}
                                                                                    alt=""/> : null
                                                                            }
                                                                        </a> :
                                                                        <div className={'profpicinn'}>
                                                                            <a data-fancybox={uuid()}
                                                                            href={this.state.userDetails && this.state.userDetails.personalInfo && this.state.userDetails.personalInfo.profileImage ? getCDNUrl(this.state.userDetails.personalInfo.profileImage) : mappingUtils.returnDefaultImage(this.state.userDetails.type)}>
                                                                                {this.state.userDetails ?
                                                                                    <img
                                                                                        src={(this.state.userDetails.personalInfo) && !_.isNull(this.state.userDetails.personalInfo.profileImage) ? getCDNUrl(this.getOptimizedImage(this.state.userDetails.personalInfo)) : mappingUtils.returnDefaultImage(this.state.userDetails.type)}
                                                                                        alt=""/> : null
                                                                                }
                                                                            </a>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className="proftopuserinfo about">
                                                                    <div className="proftopusersm">
                                                                        <figure className="userlogo">
                                                                            <a data-fancybox={uuid()}
                                                                            href={this.state.userDetails && this.state.userDetails.personalInfo && this.state.userDetails.personalInfo.profileImage ? getCDNUrl(this.state.userDetails.personalInfo.profileImage) : mappingUtils.returnDefaultImage(this.state.userDetails.type)}>
                                                                                {this.state.userDetails && this.state.userDetails.personalInfo  ?
                                                                                    <img
                                                                                        src={!_.isNull(this.state.userDetails.personalInfo) && !_.isNull(this.state.userDetails.personalInfo.profileImage)  ? getCDNUrl(this.getOptimizedImage(this.state.userDetails.personalInfo)) : mappingUtils.returnDefaultImage(this.state.userDetails.type)}
                                                                                        alt=""/> : null
                                                                                }
                                                                            </a>
                                                                        </figure>
                                                                        {this.state.userDetails.username &&
                                                                        <h1><strong>{this.state.userDetails.username}</strong></h1>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="projtopbarleft">
                                                                    <div className="mcustHorizMenu">
                                                                        <div className="mcustHorizinn">
                                                                            <ul id="tabs" className="nav">
                                                                                <li className="nav-item"><a href="javascript:void(0);" className="active">About</a></li>
                                                                                {userPostCountData?.myPost > 0 && <li className="nav-item"><Link to={`/profile-studio/${this.props.customUrl}`}>Studio</Link></li>}
                                                                                {userPostCountData?.articleCount > 0 && mappingUtils.getPrivacySettingData(this.state.privacySetting, 'feeds') && <li className="nav-item"><Link to={`/profile-article/${this.props.customUrl}`}>Articles</Link></li>}
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="profuserinfoCompany profTopBannDesc otherComp">
                                                                <div className="compTopWrap">
                                                                    <div className="compToplt">
                                                                        {this.state.userDetails.username ?
                                                                            <h1 className="h1ttl">
                                                                                {this.state.userDetails.username}

                                                                                {this.state.userDetails && this.state.userDetails.personalInfo && this.state.userDetails.personalInfo.website ?
                                                                                <span><a onClick={(event) => window.open(this.state.userDetails.personalInfo && this.sanitize(this.state.userDetails.personalInfo.website), "_blank")}
                                                                                href="javascript:void(0)" className="web"><i className="iExport"/></a></span>
                                                                                : null}
                                                                            </h1> : null
                                                                        }
                                                                        <div className="compAddressOrag">
                                                                            {this.state.userDetails && this.state.userDetails.organizationType && this.state.userDetails.type === 'COMPANY' ?
                                                                                <span>{this.state.userDetails.organizationType} </span> : null
                                                                            }
                                                                            {mappingUtils.getSharingSettingDataForUnAuth(this.state.sharingConfig, 'address') && (this.state.userDetails.contactInfo.city || this.state.userDetails.contactInfo.state || this.state.userDetails.contactInfo.country || this.state.userDetails.contactInfo.pinCode > 0) &&
                                                                            <span className="compaddress">
                                                                                {this.state.userDetails.contactInfo && this.state.userDetails.contactInfo.city}, {this.state.userDetails.contactInfo && this.state.userDetails.contactInfo.state}, {this.state.userDetails.contactInfo && this.state.userDetails.contactInfo.country}
                                                                            </span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="compTopRt">
                                                                        {mappingUtils.getSharingSettingDataForUnAuth(this.state.sharingConfig, 'contact_info') &&
                                                                        <div className="contxmenu otherCmpnyDrpdwn">
                                                                            <button type="button" className="btn"
                                                                                    data-toggle="dropdown"
                                                                                    aria-haspopup="true"
                                                                                    aria-expanded="false"><i
                                                                                className="iKebab"/></button>
                                                                            <div
                                                                                className="dropdown-menu fadeIn animated">

                                                                                <a href="javascript:void(0)"
                                                                                    onClick={this.openContactInfo}
                                                                                    className="continfo dropdown-item"><i
                                                                                    className="iInfo"/> Contact Info</a>

                                                                            </div>

                                                                            <div id="contactInfopop"
                                                                                    className="modal fade dgpopup"
                                                                                    data-backdrop="static"
                                                                                    data-keyboard="false">
                                                                                <div className="modal-dialog">
                                                                                    <div className="modal-content">
                                                                                        <div className="modal-body">
                                                                                            <div
                                                                                                className="contactInfopop">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="close"
                                                                                                    data-dismiss="modal"
                                                                                                    aria-label="Close">
                                                                                                    <span
                                                                                                        aria-hidden="true">&times;</span>
                                                                                                </button>

                                                                                                <h4>Contact
                                                                                                    Info</h4>
                                                                                                {mappingUtils.getSharingSettingDataForUnAuth(this.state.sharingConfig, 'phone_number') &&
                                                                                                    <div
                                                                                                        className="contactInfopoprow">
                                                                                                        <span>Phone Number :</span>
                                                                                                        <p>+{this.state.userDetails.contactInfo && this.state.userDetails.contactInfo.countryCode} {this.state.userDetails.contactInfo && this.state.userDetails.contactInfo.mobile}</p>
                                                                                                    </div>
                                                                                                }
                                                                                                {mappingUtils.getSharingSettingDataForUnAuth(this.state.sharingConfig, 'email') &&
                                                                                                    <div
                                                                                                        className="contactInfopoprow">
                                                                                                        <span>Email :</span>
                                                                                                        <p>{this.state.userDetails.contactInfo && this.state.userDetails.contactInfo.email}</p>
                                                                                                    </div>
                                                                                                }
                                                                                                {mappingUtils.getSharingSettingDataForUnAuth(this.state.sharingConfig, 'address') && this.state.userDetails.contactInfo && (this.state.userDetails.contactInfo.city || this.state.userDetails.contactInfo.state || this.state.userDetails.contactInfo.country || this.state.userDetails.contactInfo.pinCode > 0) &&
                                                                                                    <div
                                                                                                        className="contactInfopoprow">
                                                                                                        <span>Address :</span>
                                                                                                        <p>{this.state.userDetails.contactInfo && this.state.userDetails.contactInfo.city}, {this.state.userDetails.contactInfo && this.state.userDetails.contactInfo.state}, {this.state.userDetails.contactInfo && this.state.userDetails.contactInfo.country} {this.state.userDetails.contactInfo && !_.isUndefined(this.state.userDetails.contactInfo.pinCode) && this.state.userDetails.contactInfo.pinCode > 0 && this.state.userDetails.contactInfo.pinCode}</p>
                                                                                                    </div>
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="profuserdesccont">
                                                                    {this.state.userDetails?.personalInfo?.otherInfo && <div className="bioOtherInfo">
                                                                        <p>{this.state.userDetails?.personalInfo?.otherInfo}</p>
                                                                    </div>}
                                                                    {this.state.userDetails && this.state.userDetails.bio ?
                                                                    <ReadMoreReadLess
                                                                        id={this.state.userDetails.customUrl}
                                                                        description={this.state.userDetails.bio}/>
                                                                    : null}
                                                                </div>
                                                            </div>
                                                            {mappingUtils.getSharingSettingDataForUnAuth(this.state.sharingConfig, 'specialization') &&
                                                            <div className="organizInterestSpecial">
                                                                <div className="row">
                                                                    <div className="col-md-12">

                                                                            <div className="organizInterestSpecialBlk">
                                                                                <h2 className="title">Specialization</h2>
                                                                                {/* <div className="titlewrp">
                                                                                    <h4>Specialization</h4>
                                                                                    
                                                                                </div> */}

                                                                                <div className="organizSpecializ">
                                                                                    {this.state.userDetails && this.state.userDetails.personalInfo && (this.state.userDetails.personalInfo.specialities === null || (this.state.userDetails.personalInfo.specialities && this.state.userDetails.personalInfo.specialities.length === 0)) &&
                                                                                    <div class="zdata">
                                                                                        <div class="imgbox"><img
                                                                                            src="https://cdn.dscovr.com/images/zero-profile-left1.webp"
                                                                                            onError={(e) => {
                                                                                                e.target.onerror = null;
                                                                                                e.target.src = "https://cdn.dscovr.com/images/zero-profile-left1.png"
                                                                                            }} alt=""/></div>
                                                                                        <div class="desc">
                                                                                            <h4>No Specialization Updated!</h4>
                                                                                        </div>
                                                                                    </div>}

                                                                                    {this.state.userDetails && this.state.userDetails.personalInfo &&
                                                                                    this.state.userDetails.personalInfo.specialities && this.state.userDetails.personalInfo.specialities.map((item, index) => {
                                                                                        if (index < 10) {
                                                                                            return <span href="#" key={index}>{item}</span>;
                                                                                        }
                                                                                    })
                                                                                    }

                                                                                    {this.state.userDetails && this.state.userDetails.personalInfo
                                                                                    && this.state.userDetails.personalInfo.specialities &&
                                                                                    this.state.userDetails.personalInfo.specialities.length > 10 ?
                                                                                        <div className="text-center w-100" style={{marginTop: '13px'}}>
                                                                                            <a href="#unauthprofSpecialitiesViewpop" data-toggle="modal" className="btn morebtnsm">View All</a>
                                                                                        </div>: null}
                                                                                </div>
                                                                            </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                                        }
                                                            <UnauthSpecialitiesPopUp specialities={this.state.userDetails.personalInfo && this.state.userDetails.personalInfo.specialities}/>

                                                            <div className="bkbackdrop2">
                                                                <div className="unauthLoginPop">
                                                                    <div className="unauthLoginPopdesc">
                                                                        <a href="javascript:void(0)" onClick={this.loginRequired.bind(this)} className="bkloginBtn"><i className="iArrow-Up"/>You must <span>login</span> to explore more</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </main></>:null}
                            <LeftPanelUnauth signUpRequired={this.signUpRequired}/>
                        </div>
                    </div>
                    {this.state.loginRequired === true ? <AuthModalComponent pathname={this.state.pathname} history={this.props.history} handleLoginClose={this.handleLoginClose}/> : null}
                    {this.state.signUpRequired === true ? <SignUpModal  handleSignUpClose={this.handleSignUpClose} history={this.props.history}/> : null}
                </div>
            );}
    }
}

export default BusinessProfileByPass;
